// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const messageWrapper = "PasswordField__messageWrapper__TNAgz TextField__errorsWrapper__mLqD9 font-faces__sansRegular__c8KXl font-faces__sans__uCf65 TextField__singleError__TVfh8";
export const red = "PasswordField__red__F9FkV";
export const yellow = "PasswordField__yellow__3r9-b";
export const green = "PasswordField__green__Qmcmo";